import {ThemeType} from '../../../theme';
import {BaseEditorProps, EditorProps} from '../types';
import {} from '../../themed/functions/mapBorderToBaseProperties';
import {EditorStyleMap} from '../styles';
import {
  getDirectThemeToBasePropertyCategories,
  mapPaddingToBaseProperties,
} from '../../themed/functions';
import {mapEditorBorderToBaseProperties} from './mapEditorBorderToBaseProperties';

export const mapContainerToBaseProperties = (
  theme: ThemeType,
  focus: boolean,
  props: EditorProps,
): BaseEditorProps => {
  const {state = 'Default', clear} = props;

  const backgroundColor = EditorStyleMap[state].backgroundColor;
  const padding = EditorStyleMap[state].padding;

  return {
    backgroundColor: clear
      ? theme.colors['transparent']
      : theme.colors[backgroundColor],
    ...mapEditorBorderToBaseProperties(theme, focus, props),
    ...mapPaddingToBaseProperties(theme, padding),
    ...getDirectThemeToBasePropertyCategories(props, {
      flex: true,
      shadow: true,
    }),
  };
};
